import { type Suggestion } from './__types__/RemoteObject.ts';

const hashStringToInt = (str: string): number => {
	let hash = 5381;
	for (let i = 0; i < str.length; i++) {
		// eslint-disable-next-line no-bitwise
		hash = (hash * 33) ^ str.charCodeAt(i);
	}
	// eslint-disable-next-line no-bitwise
	return hash >>> 0;
};

export type SuggestionReasoningType = 'related' | 'explanation';

export const getSuggestionReasoningType = (
	suggestion: Suggestion,
	titlesByContentId: Map<string, string>,
): SuggestionReasoningType | null => {
	const { explanation, relatedPages } = suggestion;
	const hasExplanation = Boolean(explanation);
	const firstRelatedPageId = relatedPages?.[0];
	const relatedPageTitle = firstRelatedPageId
		? (titlesByContentId.get(String(firstRelatedPageId)) ?? '')
		: '';
	const hasRelated = relatedPageTitle.length > 0;

	const candidates: Array<SuggestionReasoningType> = [];
	if (hasRelated) candidates.push('related');
	if (hasExplanation) candidates.push('explanation');

	if (candidates.length === 0) {
		return null;
	}

	return candidates[hashStringToInt(suggestion.id) % candidates.length];
};
